import { createSlice } from "@reduxjs/toolkit";
const isLogin_local = sessionStorage.getItem("isLogin");
const localdata = JSON.parse(sessionStorage.getItem("userdata"));
// const isTemp_local = isLogin_local ? localdata.data.te_is_temp_pwd : 0;
const isTemp_local = isLogin_local
  ? localdata.te_userpasskey
  : 0;
const loginuser = isLogin_local ? localdata.te_username : "";
const loginId = isLogin_local ? localdata.te_userid : null;
const initialState = {
  isLogin: isLogin_local ? true : false,
  isForgetPassword: false,
  isTempPassword: isTemp_local,
  loginUser_id: loginId,
  loginUser_name: loginuser,
};
export const loginReducerInner = createSlice({
  name: "Login",
  initialState: initialState,
  reducers: {
    Login(state) {
      state.isLogin = true;
    },
    Logout(state) {
      state.isLogin = false;
    },
    Forget_password(state, action) {
      state.isForgetPassword = action.payload;
    },
    Update_password(state) {
      state.isForgetPassword = false;
    },
    Temp_password(state, action) {
      state.isTempPassword = action.payload;
    },
    Login_UserId(state, action) {
      state.loginUser_id = action.payload;
    },
    Login_UserName(state, action) {
      state.loginUser_name = action.payload;
    },
  },
});
